import { render, staticRenderFns } from "./BboxStatus.vue?vue&type=template&id=89e46f12&"
import script from "./BboxStatus.vue?vue&type=script&lang=ts&"
export * from "./BboxStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BboxStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports